/**
 * 正規表現用のユーティリティ関数
 */

/**
 * 文字列を正規表現で安全に使用できるようにエスケープする
 * @param string エスケープする文字列
 * @returns エスケープされた文字列
 */
export const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
